const LEAD_KEY = "jma_lead";
const APPOINTMENT_KEY = "jma_appointment";

export function toDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatLongDate(dateKey) {
  return new Intl.DateTimeFormat("en-US", { weekday: "long", month: "long", day: "numeric" }).format(new Date(`${dateKey}T12:00:00`));
}

export function formatMonth(date) {
  return new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" }).format(date);
}

export function getDemoAvailability(start = new Date()) {
  const availability = {};
  for (let offset = 1; offset <= 42; offset += 1) {
    const date = new Date(start);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + offset);
    if (date.getDay() === 0) continue;
    availability[toDateKey(date)] = date.getDay() === 6 ? ["9:30 AM", "10:30 AM", "11:30 AM"] : ["4:30 PM", "5:30 PM", "6:30 PM"];
  }
  return availability;
}

export function readStoredLead() {
  try {
    return JSON.parse(sessionStorage.getItem(LEAD_KEY) || "null");
  } catch {
    return null;
  }
}

export function storeLead(lead) {
  sessionStorage.setItem(LEAD_KEY, JSON.stringify(lead));
}

export function readStoredAppointment() {
  try {
    return JSON.parse(sessionStorage.getItem(APPOINTMENT_KEY) || "null");
  } catch {
    return null;
  }
}

export function storeAppointment(appointment) {
  sessionStorage.setItem(APPOINTMENT_KEY, JSON.stringify(appointment));
}
